import { render } from "./NoodleBody.vue?vue&type=template&id=a7469bfe&scoped=true"
import script from "./NoodleBody.vue?vue&type=script&lang=js"
export * from "./NoodleBody.vue?vue&type=script&lang=js"

import "./NoodleBody.vue?vue&type=style&index=0&id=a7469bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7469bfe"]])

export default __exports__